import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/** Redirect that carries the query string and hash along — Stripe returns to
 *  /settings?payment=success and Square to /integrations?connected=square. */
export default function KeepQueryRedirect({ to }: { to: string }) {
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: to, search, hash }} replace />;
}
